import * as React from "react";

import "../../styles/keeprite.css";

const KeepRiteTheme: React.FunctionComponent = () => {

    React.useEffect(() => {
		const favicon = document.querySelector<HTMLLinkElement>("link[rel='shortcut icon']");
        if (favicon !== null) {
            favicon.href = "/favicon/keeprite_icon.png";
        }
	}, []);

    return (<></>);
};

export default KeepRiteTheme;